import $ from "jquery"
import "slick-carousel-latest"

$('.mobile-scroll__wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrow: true,
    fade: true,
    dots: false,
    customPaging: function (slider, i) {
      return slider.currentSlide + '/' + (i + 1);
  }
});

$('.js-hero-footer-slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrow: true,
    fade: true,
    dots: false
});

$('.outsourcing-slider__text').each(function () {
  var navElement = $(this).parents('.global-container').find('.outsourcing-slider__wrapper')
  $(this).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 15000,
    pauseOnHover: true,
    pauseOnFocus: false,
    infinite: true,
    asNavFor: navElement,
    row: 0,
    dotsClass: 'slider-dots',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false
        }
      }
    ]
  });
})

$('.outsourcing-slider__wrapper').each(function () {
  var navElement = $(this).parents('.global-container').find('.outsourcing-slider__text');
  
  $(this).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: navElement,
    arrows: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 15000,
    pauseOnHover: true,
    pauseOnFocus: false,
    row: 0,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          dotsClass: 'slider-dots'
        }
      }
    ]
  });

  // On before slide change
  $('.outsourcing-slider__text').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.slider-dots button').html('');
  }).trigger('beforeChange');

  // On before slide change
  $('.outsourcing-slider__text').on('afterChange', function(event, slick, currentSlide){
    $('.slider-dots button').html('');
    $('.slider-dots .slick-active button')
      .html(`<svg class="progress-svg" width="40" height="40">
      <g transform="translate(20,20)">
        <circle class="circle-go" r="12" cx="0" cy="0"></circle>
      </g>
      </svg>`);
  }).trigger('afterChange');

  var sliderTimer = 15000;
  var $imageSlider = $(this);
  var progressBarEl = $(this).parent().find('.slider-progress');

  function progressBar(status) {
    progressBarEl.find('span').removeAttr('style');
    progressBarEl.find('span').removeClass('active');
    setTimeout(function(){
      progressBarEl.find('span').addClass('active');
    }, 100);
  }
  progressBar();
  $imageSlider.on('beforeChange', function(e, slick, nextSlide) {
    progressBar();
  });
})

$('.outsourcing-slider .slider-dots').on('mouseover',function() {
  $('.outsourcing-slider__text').slick('slickPause');
  $('.outsourcing-slider__wrapper').slick('slickPause');
  $('.slider-dots .slick-active button svg').remove();
});

$('.outsourcing-slider .slider-dots').on('mouseout',function() {
  $('.outsourcing-slider__text').slick('slickPlay');
  $('.outsourcing-slider__wrapper').slick('slickPlay');
  $('.slider-dots .slick-active button')
		 .html(`<svg class="progress-svg" width="40" height="40">
		<g transform="translate(20,20)">
      <circle class="circle-go" r="12" cx="0" cy="0"></circle>
		</g>
    </svg>`);
});

// mobile counter 

let $slickElement = $('.js-slider-mobile');
let $status = $('.js-mobile-counter');
$slickElement.each(function() {
  var thisEl = $(this)
  $(this).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    let i = (currentSlide ? currentSlide : 0) + 1;
    thisEl.parent().find('.js-mobile-counter').text(i + '/' + slick.slideCount);
  });
})